const SINGULAR = {
    year: 'year',
    month: 'month',
    week: 'week',
    day: 'day',
    hour: 'hour',
    minute: 'minute',
    second: 'second',
};
const PLURAL = {
    year: 'years',
    month: 'months',
    week: 'weeks',
    day: 'days',
    hour: 'hours',
    minute: 'minutes',
    second: 'seconds',
};
export const DURATION_LABELS = {
    SINGULAR,
    PLURAL,
};
